import React from 'react';
import axios from 'axios';

export default class Failed extends React.Component {

  async componentDidMount() {
    
    var date = new Date()
    var year = date.getFullYear()
    document.cookie = 'hasFailed=true;expires=Thu, 18 Dec '+ (year + 1) +' 12:00:00 UTC;'
    //axios.defaults.baseURL = 'http://localhost:3001';
    let user = this.props.getCookie('loggedInUser')
    let userID = this.props.getCookie('loggedInId')
    var timings
    await axios.get('/api/getTimings', {
      params: {
        userID: userID
      }
    })
    .then(function(res, err) {
      timings = res.data
    }) 
    console.log("mounted", user)
    axios.get('/api/deActivateUser', {
      params: {
        email_addr: user,
        finalTest: this.props.failedFinalTest,
        testStats: this.props.individualTests,
        timings: timings
      }
    })
    .then(function(res, err) {
      console.log(res)
    })
  }

  render () {
    return (
      <div style={{overflowY: 'auto'}}>
        Thank you for working on the training set. 
        Unfortunately, your error rate is too high to allow you to continue. 
        We will end your contract on upwork and leave a positive review for your efforts.
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Failed.js